module.exports = __webpack_public_path__ + "img/nf.29ba87ff.png";